<!-- 模型等级横向展示块 -->
<template>
  <div class="modelList">
    <div class="modelListContent width">
      <div class="modelListItem" :class="item.modelModel" v-for="(item,i) in modelList" :key="i">
        <template v-if="item.bb?'':'show'">
          <img :src="item.img" alt srcset />
          <div class="modelItemCon">
            <h4>{{item.title}}</h4>
            <div class="pp">
              <p v-for="(item1,i1) in item.content" :key="i1">{{item1}}</p>
            </div>
          </div>
        </template>

        <template>
          <div v-if="item.bb?'show':''">
            <div class="modelItemCon">
              <h4>{{item.title}}</h4>
              <div class="pp">
                <p v-for="(item1,i1) in item.content" :key="i1">{{item1}}</p>
              </div>
            </div>
            <img :src="item.img" alt srcset />
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  components: {},
  props: {
    modelList: Array,
  },
  data() {
    return {
      show: true,
    }
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {},
}
</script>

<style lang="less" scoped>
.modelListContent {
  display: flex;
  .modelListItem {
    flex: 1;
    margin: 0 5px;
    background-color: rgba(48, 53, 67, 1);
    img {
      width: 100%;
      height: 140px;
    }
    .modelItemCon {
      color: #fff;
      h4 {
        text-align: center;
        padding: 0;
        margin: 10px 0 0 0;
      }
      p {
        padding: 0 10px;
        text-indent: 2em;
        line-height: 20px;
      }
      .pp {
        p {
          color: #fff;
        }
      }
    }
  }
  .lr {
    display: flex;
    img {
      flex: 1;
      max-width: 50%;
      height: 320px;
    }
    .modelItemCon {
      flex: 1;
      h4 {
        margin-top: 30px;
      }
    }
  }
}
</style>
